import { Injectable } from '@angular/core';
import { DeactiveDialogService } from '@shared/services/deactivate-guard.service';
import { L10nTranslationService } from 'angular-l10n';

/**
 * Records decorator for SharedModule.DeactiveDialogService
 */
@Injectable({ providedIn: 'root' })
export class RecordDeactivatorDialog {
  private confirmText = 'recordsSearch.yes';
  private cancelText = 'recordsSearch.no';
  private discardAllChanges = 'recordsSearch.discardAllChanges';
  private unSavedChanges = 'recordsSearch.unSavedChanges';

  constructor(
    private sharedDeactivateDialogService: DeactiveDialogService,
    translationService: L10nTranslationService
  ) {
    this.confirmText = translationService.translate(this.confirmText);
    this.cancelText = translationService.translate(this.cancelText);
    this.discardAllChanges = translationService.translate(this.discardAllChanges);
    this.unSavedChanges = translationService.translate(this.unSavedChanges);
  }

  askSaveDialog() {
    return this.showDialog(this.unSavedChanges);
  }

  askStayDialog() {
    return this.showDialog(this.discardAllChanges);
  }

  private showDialog(msg: string) {
    return this.sharedDeactivateDialogService
      .setShowCloseButton(true)
      .setSwap(false)
      .showDialog(msg, this.confirmText, this.cancelText, ' ');
  }
}
